/**
 * Shared cap for the maximum number of simultaneously expanded rows
 * tracked in the URL across the dashboard's two row-expand surfaces:
 *
 *   - FeedbackPage (`useFeedbackUrlState` → `?expanded=`)
 *   - UserDrilldown Activity tab (`useActivityUrlState` → `?activity_expanded=`)
 *
 * Each expand triggers a `/feedback/trace-detail` fetch and adds the trace
 * ID into the URL (~24 chars + delimiter), so an unbounded list would
 *   (a) bloat the address bar,
 *   (b) thrash the browser history stack on rapid toggles, and
 *   (c) cascade-fetch trace detail for every entry on page reload.
 *
 * 10 covers the realistic admin-triage workflow ("compare the worst handful
 * of yesterday's ratings side-by-side") with margin. Both hooks read this
 * single source of truth so the cap stays consistent if it ever changes.
 */

export const EXPANDED_MAX = 10;
